import './TabContainer.css';

const Tab = ({ name, label, activeTab, onClick }) => {
    return (
        <button
            className={`tab ${activeTab === name ? 'active' : ''}`}
            onClick={() => onClick(name)}
        >
            {label}
        </button>
    );
}

export default Tab;